// 代理商管理
import $ from '../base'

export default {

  // 代理商 - 列表
  agentList: $.post('agent/queryAgents'),

  // 代理商 - 新增/编辑
  agentCreateUpdate: $.post('agent/addOrEditAgent'),

  // 代理商 - 商品 - 列表
  agentCommodityList: $.post('agent/queryAgentCommodities'),

  // 代理商 - 商品 - 列表
  agentCommoditys: $.post('agent/queryAgentCommoditiesList'),

  // 代理商 - 商品- 新增/编辑
  agentCommodityCreateUpdate: $.post('agent/addOrEditAgentCommodity'),

  // 代理商 - 商品 - 删除
  agentCommodityDelete: $.post('agent/delAgentCommodity'),

  // 代理商流水查询导出
  outQueryAgentFlow: $.BASE_URL + '/order/outQueryAgentFlow',

  // 代理商 - 接口权限 - 列表
  agentPermissionsList: $.post('/agentPermissions/queryPage'),

  // 代理商 - 接口权限 - 状态更新
  agentPermissionsUpdateState: $.post('/agentPermissions/updateUseState'),

  // 代理商 - 接口权限 - 代理商下拉
  queryAgentCommodities: $.post('/agent/queryCommissionAgentList'),

  // 代理商 - 接口权限 - 接口下拉
  getOutInterface: $.post('/agentPermissions/getOutInterface'),
  // 代理商 - 接口权限 - 新增
  agentPermissionsAdd: $.post('/agentPermissions/save')

}
